import { FlexContainer, Buttons, Text } from '@taxdown/piccolo-web';
import { showChat } from 'Services/chat';
import { locizeNS } from 'Services/i18n';
import useTranslation from 'Hooks/useTranslation';
import { lottiesPaths } from 'Constants/lottiesPaths';
import {
  discardedStageContact,
  discardedStages,
  discardedStagesToRedirectLink,
} from 'Constants/stages';
import { openLinkInNewTab } from 'Utils/links';
import { DISCARDED_HELP_URL } from 'Constants/helpsUrl';
import * as Styled from '../styles';
import { DiscardedProps } from './types';

const Discarded = ({ tax: { taxYear, stage } }: DiscardedProps): JSX.Element => {
  const { t } = useTranslation(locizeNS.DASHBOARD);

  return (
    <FlexContainer justify="center" direction="column" align="center" gap="dimension_08">
      <Text size="L_L_S" color="dark" type="headline">
        {taxYear}
      </Text>
      <Text type="paragraphs" size="L_L_M" color="dark" align="center">
        {t(`Dashboard.${discardedStages[stage.toUpperCase()]}.message`)}
      </Text>
      <Styled.StyledLottie options={{ path: lottiesPaths.DISCARDED }} />
      <Text type="paragraphs" color="dark" size="M_L_S" align="center">
        {t(`Dashboard.${discardedStages[stage.toUpperCase()]}.title`)}
      </Text>
      <Text type="paragraphs" color="dark" size="S_S_S" align="center">
        {t(`Dashboard.${discardedStages[stage.toUpperCase()]}.description`)}
      </Text>
      {discardedStagesToRedirectLink.includes(stage) && (
        <Buttons.Classic
          size="m"
          mode="primary"
          label={t('Dashboard.discarded.moreInfo')}
          onClick={() => openLinkInNewTab(DISCARDED_HELP_URL)}
        />
      )}
      {discardedStageContact.includes(stage) && (
        <Buttons.Classic size="m" mode="primary" label={t('Button.contact')} onClick={showChat} />
      )}
    </FlexContainer>
  );
};

export default Discarded;
